import iconImg from "./icon.png";
const GEO_OPTION = {
    map: "china",
    aspectScale: 1,
    roam: true,
    scaleLimit: {
      //滚轮缩放的极限控制
      min: 0,
      max: 100,
    },
    layoutCenter: ["15%", "70%"], //地图位置
    layoutSize: "300%",
    itemStyle: {
      normal: {
        borderColor: "rgba(66, 238, 251, 1)",
        shadowColor: "rgba(66, 238, 251, 1)",
        borderWidth: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
        areaColor: "rgba(27, 97, 179, 1)",
      },
      emphasis: {
        areaColor: "rgba(27, 97, 179, 1)",
      },
    },
    regions: [
      {
        name: "南海诸岛",
        itemStyle: {
          areaColor: "rgba(0, 10, 52, 1)",

          borderColor: "rgba(0, 10, 52, 1)",
          normal: {
            opacity: 0,
            label: {
              show: false,
              color: "#009cc9",
            },
          },
        },
        label: {
          show: false,
          color: "#FFFFFF",
          fontSize: 12,
        },
      },
    ],
  };

// let img = document.createElement("img");
// img.src = bgImg;

const MAP_SERIES = {
  type: "map",
  mapType: "china",
  roam: true,
  aspectScale: 1,
  layoutCenter: ["15%", "70%"], //地图位置
  layoutSize: "300%",
  zoom: 1, //当前视角的缩放比例
  scaleLimit: {
    //滚轮缩放的极限控制
    min: 0,
    max: 100,
  },
  itemStyle: {
    normal: {
      borderColor: "rgba(76, 239, 253, 0.7)", // 设置地图内边框样式
      borderWidth: 1,
      areaColor: '#ffffff',
    },
    emphasis: {
      areaColor: "rgba(76, 239, 253, 0.7)",
      label: {
        color: "#fff",
      },
    },
  },
};

const POSITION_MAP = {
  topCenter: {
    left: "center",
    top: "top",
  },
  topLeft: {
    left: "left",
    top: "top",
  },
  topRight: {
    top: "top",
    left: "right",
  },
  bottomCenter: {
    top: "bottom",
    left: "center",
  },
  bottomLeft: {
    top: "bottom",
    left: "left",
  },
  bottomRight: {
    top: "bottom",
    left: "right",
  },
};

const LABEL_SERIES = {
  type: 'scatter',
  label: {
    show: true,
    offset: [0, -50],
  },
  coordinateSystem: 'geo',
  symbol: `image://${iconImg}`,
  symbolSize: 40,
  z: 99,
}

const LABEL_OPTION = {
  // 富文本配置项, 根据ui设计展示label，具体参考echarts富文本标签文档
    area: {
        width: 60,
        height: 45,
        backgroundColor: {
            image: '',
        },
    },
    text: {
        color: "#ffffff",
        fontSize: 13,
        align: "center",
        verticalAlign: "bottom",
        width: "120%",
        height: 21,
        padding: [0, 5, 2, 5],
        backgroundColor: {
            image: '',
        },
    },
};

export {
    GEO_OPTION,
    POSITION_MAP,
    MAP_SERIES,
    LABEL_OPTION,
    LABEL_SERIES,
};
